import { createAction, props } from '@ngrx/store';
import { IAuthSlice } from './auth.reducer';

export const login = createAction(
  '[Auth API] Login Success',
  props<IAuthSlice>()
);
export const refresh = createAction(
  '[Auth API] Refresh Success',
  props<IAuthSlice>()
);
export const logout = createAction('[Auth API] Logout Success');
